var Handlebars = require("/root/project/webapp/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "        <h5>"
    + alias2(alias1((depth0 != null ? depth0.currentUserMessage : depth0), depth0))
    + "</h5>\n        <h5 style=\"font-weight: 700;\">\n            <img class=\"img-circle icon\" src=\""
    + alias2(__default(require("/root/project/webapp/src/common/ui/template/helper/image.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.userImage : depth0),"small",{"name":"image","hash":{},"data":data}))
    + "\" alt=\"icon\"\n            data-toggle=\"tooltip\" data-placement=\"bottom\"\n                title=\""
    + alias2(alias1((depth0 != null ? depth0.username : depth0), depth0))
    + "\"/> "
    + alias2(alias1((depth0 != null ? depth0.username : depth0), depth0))
    + "\n        </h5>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div style=\"text-align: center\">\n    <img src=\"/assets/balus-icon.svg\" style=\"width: 100px;\">\n    <h3 style=\"font-weight: 700;\">"
    + alias2(alias1((depth0 != null ? depth0.title : depth0), depth0))
    + "</h3>\n</div>\n\n<div style=\"text-align: center; margin-top: 30px\">\n    <h5>"
    + alias2(alias1((depth0 != null ? depth0.info : depth0), depth0))
    + "</h5>\n"
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.isPermissionError : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n<div style=\"text-align: center; margin-top: 20px\" class=\"\n    col-sm-offset-2 col-sm-8\n    col-md-offset-3 col-md-6\n    col-lg-offset-4 col-lg-4\n\">\n    <a style=\"font-weight: 700;\" class=\"btn btn-primary btn-raised\" href=\""
    + alias2(alias1((depth0 != null ? depth0.accountsPageURL : depth0), depth0))
    + "\">\n        "
    + alias2(__default(require("/root/project/webapp/src/common/ui/template/helper/i18n.js")).call(alias3,"error:error_page.permission_error.change_account",{"name":"i18n","hash":{},"data":data}))
    + "\n    </a>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./common/ui/template/error.hbs
// module id = 1290
// module chunks = 0